'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FlickityService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

require('flickity');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* global Flickity */
var FlickityService = exports.FlickityService = function () {
    function FlickityService($timeout, $q, $rootScope, $log) {
        'ngInject';

        _classCallCheck(this, FlickityService);

        this.$timeout = $timeout;
        this.$q = $q;
        this.$rootScope = $rootScope;
        this.$log = $log;

        this.instances = [];
    }

    /**
     * Create a new Flickity instance
     *
     * @param {Element} element
     * @param {String} id
     * @param {Object} options
     * @return {Object} instance
     */


    _createClass(FlickityService, [{
        key: 'create',
        value: function create(element) {
            var _this = this;

            var id = arguments.length <= 1 || arguments[1] === undefined ? this.instances.length + 1 : arguments[1];
            var options = arguments[2];


            // Check to see if the ID is already in use
            if (this._findObjectById(this.instances, id)) {
                var index = this._getFlickityIndex(id);
                this.$log.error('This ID is already in use: ', this.instances[index]);

                return false;
            }

            // Define the new instance
            var instance = {
                id: id,
                instance: new Flickity(element, options)
            };

            // Save this instance to the array
            this.instances.push(instance);

            return this.$q(function (resolve) {

                // Bind to all events
                _this._bindEvents(id).then(function () {
                    resolve(instance);
                });
            });
        }

        /**
         * Destroy a Flickity instance
         *
         * @param {String} id
         * @return {Object} instance
         */

    }, {
        key: 'destroy',
        value: function destroy(id) {
            var _this2 = this;

            var pauseBeforeDestruction = 100;
            var flickityIndex = this._getFlickityIndex(id);

            return this.$q(function (resolve, reject) {

                if (flickityIndex < 0) {
                    reject('Instance ' + id + ' not found');
                }

                // Pause to allow other scope cleanup to occur
                // NOTE: Without this pause, Flickity is being destroyed before the view containing the
                // directive can leave view
                _this2.$timeout(function () {

                    // Destroy the Flickity instance
                    _this2.instances[flickityIndex].instance.destroy();

                    // Remove the instance from the array
                    _this2.instances.splice(flickityIndex, 1);

                    resolve('Instance ' + id + ' destroyed.');
                }, pauseBeforeDestruction);
            });
        }

        /**
         * Move to the next slide
         *
         * @param {string} id
         * @param {Bool} isWrapped
         * @return {Object} instance
         */

    }, {
        key: 'next',
        value: function next(id, isWrapped) {
            var _this3 = this;

            var flickityIndex = this._getFlickityIndex(id);

            return this.$q(function (resolve, reject) {
                if (flickityIndex < 0) {
                    reject('Instance ' + id + ' not found');
                } else {
                    // Move to the next slide
                    _this3.instances[flickityIndex].instance.next(isWrapped);

                    resolve(_this3.instances[flickityIndex]);
                }
            });
        }

        /**
         * Move to the previous slide
         *
         * @param {string} id
         * @param {Bool} isWrapped
         * @return {Object} instance
         */

    }, {
        key: 'previous',
        value: function previous(id, isWrapped) {
            var _this4 = this;

            var flickityIndex = this._getFlickityIndex(id);

            return this.$q(function (resolve, reject) {
                if (flickityIndex < 0) {
                    reject('Instance ' + id + ' not found');
                } else {
                    // Move to the previous slide
                    _this4.instances[flickityIndex].instance.previous(isWrapped);

                    resolve(_this4.instances[flickityIndex]);
                }
            });
        }

        /**
         * Select a slide
         *
         * @param {String} id
         * @param {Integer} index
         * @param {Bool} isWrapped
         * @param {Bool} isInstant
         * @return {Object} instance
         */

    }, {
        key: 'select',
        value: function select(id, index) {
            var _this5 = this;

            var isWrapped = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];
            var isInstant = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];

            var flickityIndex = this._getFlickityIndex(id);

            return this.$q(function (resolve, reject) {
                if (flickityIndex < 0) {
                    reject('Instance ' + id + ' not found');
                } else {
                    // Move to the selected slide
                    _this5.instances[flickityIndex].instance.select(index, isWrapped, isInstant);

                    resolve(_this5.instances[flickityIndex]);
                }
            });
        }

        /**
         * Get the current slide index
         *
         * @param {String} id
         * @return {Integer} selectedIndex
         */

    }, {
        key: 'selectedIndex',
        value: function selectedIndex(id) {
            var _this6 = this;

            var flickityIndex = this._getFlickityIndex(id);

            return this.$q(function (resolve, reject) {
                if (flickityIndex < 0) {
                    reject('Instance ' + id + ' not found');
                } else {
                    // Return the current index
                    resolve(_this6.instances[flickityIndex].instance.selectedIndex);
                }
            });
        }

        /**
         * Resize the gallery and re-position cells.
         *
         * @param {String} id
         * @return {Object} instance
         */

    }, {
        key: 'resize',
        value: function resize(id) {
            var _this7 = this;

            var flickityIndex = this._getFlickityIndex(id);

            return this.$q(function (resolve, reject) {
                if (flickityIndex < 0) {
                    reject('Instance ' + id + ' not found');
                } else {
                    // Trigger the resize
                    _this7.instances[flickityIndex].instance.resize();

                    resolve(_this7.instances[flickityIndex]);
                }
            });
        }

        /**
         * Position cells at selected position.
         * Trigger reposition after the size of a cell has been changed.
         *
         * @param {String} id
         * @return {Object} instance
         */

    }, {
        key: 'reposition',
        value: function reposition(id) {
            var _this8 = this;

            var flickityIndex = this._getFlickityIndex(id);

            return this.$q(function (resolve, reject) {
                if (flickityIndex < 0) {
                    reject('Instance ' + id + ' not found');
                } else {
                    // Trigger the resize
                    _this8.instances[flickityIndex].instance.reposition();

                    resolve(_this8.instances[flickityIndex]);
                }
            });
        }

        /**
         * Re-collect all cell elements in `flickity-slider`.
         *
         * @param {String} id
         * @return {Object} instance
         */

    }, {
        key: 'reloadCells',
        value: function reloadCells(id) {
            var _this9 = this;

            var flickityIndex = this._getFlickityIndex(id);

            return this.$q(function (resolve, reject) {
                if (flickityIndex < 0) {
                    reject('Instance ' + id + ' not found');
                } else {
                    // Reload cells
                    _this9.instances[flickityIndex].instance.reloadCells();

                    resolve(_this9.instances[flickityIndex]);
                }
            });
        }

        /**
         * Get the Flickity instance
         *
         * @param {String} id
         * @return {Object} instance
         */

    }, {
        key: 'get',
        value: function get(id) {
            var _this10 = this;

            var flickityIndex = this._getFlickityIndex(id);

            return this.$q(function (resolve, reject) {
                if (flickityIndex < 0) {
                    reject('Instance ' + id + ' not found');
                } else {
                    resolve(_this10.instances[flickityIndex]);
                }
            });
        }

        /**
         * Get the first Flickity instance
         *
         * @return {Object} instance
         */

    }, {
        key: 'getFirst',
        value: function getFirst() {
            var _this11 = this;

            return this.$q(function (resolve, reject) {
                if (!_this11.instances || _this11.instances.length < 1) {
                    reject('No instances exist');
                } else {
                    resolve(_this11.instances[0]);
                }
            });
        }

        /**
         * Get the Flickity instance
         *
         * @param {Element} element
         * @return {Object} instance
         */

    }, {
        key: 'getByElement',
        value: function getByElement(element) {
            return this.$q(function (resolve, reject) {
                var instance = Flickity.data(element);

                if (instance) {
                    resolve(instance);
                } else {
                    reject('Instance not found for ' + element);
                }
            });
        }

        /**
         * Prepend elements and create cells to the beginning of the gallery.
         *
         * @param {String} id
         * @param {*} element(s) - jQuery object, Array of Elements, Element, or NodeList
         * @return {Object} instance
         */

    }, {
        key: 'prepend',
        value: function prepend(id, elements) {
            var _this12 = this;

            var flickityIndex = this._getFlickityIndex(id);

            return this.$q(function (resolve, reject) {
                if (flickityIndex < 0) {
                    reject('Instance ' + id + ' not found');
                } else {
                    // Prepend the slides
                    _this12.instances[flickityIndex].instance.prepend(elements);

                    resolve(_this12.instances[flickityIndex]);
                }
            });
        }

        /**
         * Append elements and create cells to the end of the gallery.
         *
         * @param {String} id
         * @param {*} element(s) - jQuery object, Array of Elements, Element, or NodeList
         * @return {Object} instance
         */

    }, {
        key: 'append',
        value: function append(id, elements) {
            var _this13 = this;

            var flickityIndex = this._getFlickityIndex(id);

            return this.$q(function (resolve, reject) {
                if (flickityIndex < 0) {
                    reject('Instance ' + id + ' not found');
                } else {
                    // Append the slides
                    _this13.instances[flickityIndex].instance.append(elements);

                    resolve(_this13.instances[flickityIndex]);
                }
            });
        }

        /**
         * Insert elements into the gallery and create cells at the desired index.
         *
         * @param {String} id
         * @param {*} element(s) - jQuery object, Array of Elements, Element, or NodeList
         * @param {Integer} index - Zero based index
         * @return {Object} instance
         */

    }, {
        key: 'insert',
        value: function insert(id, elements, index) {
            var _this14 = this;

            var flickityIndex = this._getFlickityIndex(id);

            return this.$q(function (resolve, reject) {
                if (flickityIndex < 0) {
                    reject('Instance ' + id + ' not found');
                } else {
                    // Insert the slides
                    _this14.instances[flickityIndex].instance.insert(elements, index);

                    resolve(_this14.instances[flickityIndex]);
                }
            });
        }

        /**
         * Get the elements of the cells
         *
         * @param {String} id
         * @return {Array} cellElements
         */

    }, {
        key: 'getCellElements',
        value: function getCellElements(id) {
            var _this15 = this;

            var flickityIndex = this._getFlickityIndex(id);

            return this.$q(function (resolve, reject) {
                if (flickityIndex < 0) {
                    reject('Instance ' + id + ' not found');
                } else {
                    resolve(_this15.instances[flickityIndex].instance.getCellElements());
                }
            });
        }

        /**
         * Get the elements of the cells
         *
         * @param {String} id
         * @return {Object} instance
         */

    }, {
        key: 'remove',
        value: function remove(id, elements) {
            var _this16 = this;

            var flickityIndex = this._getFlickityIndex(id);

            return this.$q(function (resolve, reject) {
                if (flickityIndex < 0) {
                    reject('Instance ' + id + ' not found');
                } else {
                    _this16.instances[flickityIndex].instance.remove(elements);

                    resolve(_this16.instances[flickityIndex]);
                }
            });
        }

        /**
         * Get the currently selected cell element
         *
         * @param {String} id
         * @return {Element} selectedCellElement
         */

    }, {
        key: 'selectedElement',
        value: function selectedElement(id) {
            var _this17 = this;

            var flickityIndex = this._getFlickityIndex(id);

            return this.$q(function (resolve, reject) {
                if (flickityIndex < 0) {
                    reject('Instance ' + id + ' not found');
                } else {
                    resolve(_this17.instances[flickityIndex].instance.selectedElement);
                }
            });
        }

        /**
         * Get an array of all cells
         *
         * @param {String} id
         * @return {Array} cells
         */

    }, {
        key: 'cells',
        value: function cells(id) {
            var _this18 = this;

            var flickityIndex = this._getFlickityIndex(id);

            return this.$q(function (resolve, reject) {
                if (flickityIndex < 0) {
                    reject('Instance ' + id + ' not found');
                } else {
                    resolve(_this18.instances[flickityIndex].instance.cells);
                }
            });
        }

        //
        // Helper methods
        //


        /**
         * Find the index for a Flickity instance
         *
         * @param {String} id
         * @return {Integer} flickityIndex
         */

    }, {
        key: '_getFlickityIndex',
        value: function _getFlickityIndex(id) {
            var foundIndex = void 0;

            // If no instances exist
            if (!this.instances.length) {

                foundIndex = -1;
            } else {
                // if instances do exist

                // Check the ID of each instance
                this.instances.forEach(function (instance, index) {

                    // If it matches our ID, set the index
                    if (instance.id === id) {
                        foundIndex = index;
                    }
                });
            }

            return foundIndex;
        }
    }, {
        key: '_bindEvents',
        value: function _bindEvents(id) {
            var _this19 = this;

            var flickityIndex = this._getFlickityIndex(id);

            if (flickityIndex < 0) {
                return false;
            }

            return this.$q(function (resolve) {
                var ID = _this19.instances[flickityIndex].id;

                _this19.instances[flickityIndex].instance.on('cellSelect', function () {
                    _this19.$rootScope.$emit('Flickity:' + ID + ':cellSelect', _this19.instances[flickityIndex]);
                });

                _this19.instances[flickityIndex].instance.on('settle', function () {
                    _this19.$rootScope.$emit('Flickity:' + ID + ':settle', _this19.instances[flickityIndex]);
                });

                _this19.instances[flickityIndex].instance.on('dragStart', function (event, pointer) {
                    _this19.$rootScope.$emit('Flickity:' + ID + ':dragStart', {
                        event: event,
                        pointer: pointer
                    });
                });

                _this19.instances[flickityIndex].instance.on('dragMove', function (event, pointer, moveVector) {
                    _this19.$rootScope.$emit('Flickity:' + ID + ':dragMove', {
                        event: event,
                        pointer: pointer,
                        moveVector: moveVector
                    });
                });

                _this19.instances[flickityIndex].instance.on('dragEnd', function (event, pointer) {
                    _this19.$rootScope.$emit('Flickity:' + ID + ':dragEnd', {
                        event: event,
                        pointer: pointer
                    });
                });

                _this19.instances[flickityIndex].instance.on('pointerDown', function (event, pointer) {
                    _this19.$rootScope.$emit('Flickity:' + ID + ':pointerDown', {
                        event: event,
                        pointer: pointer
                    });
                });

                _this19.instances[flickityIndex].instance.on('pointerMove', function (event, pointer, moveVector) {
                    _this19.$rootScope.$emit('Flickity:' + ID + ':pointerMove', {
                        event: event,
                        pointer: pointer,
                        moveVector: moveVector
                    });
                });

                _this19.instances[flickityIndex].instance.on('pointerUp', function (event, pointer) {
                    _this19.$rootScope.$emit('Flickity:' + ID + ':pointerUp', {
                        event: event,
                        pointer: pointer
                    });
                });

                _this19.instances[flickityIndex].instance.on('staticClick', function (event, pointer, cellElement, cellIndex) {
                    _this19.$rootScope.$emit('Flickity:' + ID + ':staticClick', {
                        event: event,
                        pointer: pointer,
                        cellElement: cellElement,
                        cellIndex: cellIndex
                    });
                });

                _this19.instances[flickityIndex].instance.on('lazyLoad', function (event, cellElement) {
                    _this19.$rootScope.$emit('Flickity:' + ID + ':lazyLoad', {
                        event: event,
                        cellElement: cellElement
                    });
                });

                resolve(true);
            });
        }

        /**
         * Find an object within an array by ID
         *
         * @param {Array} source
         * @param {String} id
         * @return {Object} match
         */

    }, {
        key: '_findObjectById',
        value: function _findObjectById(source, id) {
            return source.filter(function (object) {
                return object.id === id;
            })[0];
        }
    }]);

    return FlickityService;
}();


/** WEBPACK FOOTER **
 ** ./src/flickity.service.js
 **/